import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

export default function Job({ data, editedDataHandler, spLoader }) {
    const [upload, setUpload] = useState("");
    const [fileName, setFileName] = useState("");
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        job: data.job,
        workplace: data.workplace,
        specialty: data.specialty,
        job_group: data.job_group,
        resume: upload,
    });

    const onChangeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [errors, setErrors] = useState({
        jobErr: "",
        workplaceErr: "",
        specialtyErr: "",
        job_groupErr: "",
        resumeErr: "",
    });

    const handleFormErr = () => {
        let jobErr = "";
        let workplaceErr = "";
        let specialtyErr = "";
        let job_groupErr = "";
        let resumeErr = "";

        if (formData.job === "" || formData.job === null) {
            jobErr = t("Src.Pages.UserPages.UserProfile.Job.jobErr");
        }
        if (formData.workplace === "" || formData.workplace === null) {
            workplaceErr = t(
                "Src.Pages.UserPages.UserProfile.Job.workplaceErr"
            );
        }
        if (formData.specialty === "" || formData.specialty === null) {
            specialtyErr = t(
                "Src.Pages.UserPages.UserProfile.Job.specialtyErr"
            );
        }
        if (formData.job_group === "" || formData.job_group === null) {
            job_groupErr = t(
                "Src.Pages.UserPages.UserProfile.Job.job_groupErr"
            );
        }
        if (formData.resume === "" || formData.resume === null) {
            resumeErr = t("Src.Pages.UserPages.UserProfile.Job.resumeErr");
        }

        setErrors({
            ...errors,
            jobErr,
            workplaceErr,
            specialtyErr,
            job_groupErr,
            resumeErr,
        });

        if (
            jobErr === "" &&
            workplaceErr === "" &&
            specialtyErr === "" &&
            job_groupErr === "" &&
            resumeErr === ""
        ) {
            return true;
        }

        return false;
    };

    const sendData = (e) => {
        e.preventDefault();

        let noErr = handleFormErr();

        if (!noErr) return false;

        editedDataHandler(e, formData);
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const getFileHandle = async (e) => {
        let file = e.currentTarget.files[0];

        let file64 = await toBase64(file);

        // if(file.type?.toString().slice(0, 6) !== "image/") {
        //   // setError({...error, errUpload: "فرمت فایل نامعتبر است" })
        //   setFileName("")
        //   setUpload("")
        //   return false
        // }else {
        //   // setError({...error, errUpload: "" })
        // }

        if (file.size?.toString() > 1024 * 1024) {
            // setError({...error, errUpload: "حجم فایل بیشتر از 1 مگابایت میباشد" })
            // setFileName("")
            // setUpload("")
            return false;
        } else {
            // setError({...error, errUpload: "" })
        }

        setFileName(file.name);

        setUpload(file64);
    };

    useEffect(() => {
        setFormData({ ...formData, resume: upload });
    }, [upload]);

    return (
        <div className="page-load-fade">
            <form className="general-info-form">
                <Form.Group controlId="job">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.OccupationInfo.Occupation.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.job}
                        name="job"
                        onChange={onChangeHandler}
                        className={errors.jobErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.jobErr ? "block" : "none",
                        }}
                    >
                        {errors.jobErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="office">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.OccupationInfo.PlaceOfOccupation.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.workplaceErr}
                        name="workplace"
                        onChange={onChangeHandler}
                        className={errors.workplaceErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.workplaceErr ? "block" : "none",
                        }}
                    >
                        {errors.workplaceErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="profession">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.OccupationInfo.Proficiency.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.specialty}
                        name="specialty"
                        onChange={onChangeHandler}
                        className={errors.specialtyErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.specialtyErr ? "block" : "none",
                        }}
                    >
                        {errors.specialtyErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="currentgroup">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.OccupationInfo.CurrentGroup.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.job_group}
                        name="job_group"
                        onChange={onChangeHandler}
                        className={errors.job_groupErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.job_groupErr ? "block" : "none",
                        }}
                    >
                        {errors.job_groupErr}
                    </div>
                </Form.Group>

                {/* <Form.Group controlId="resume" className="form_group_badge">
          <div className="bt-form">
            <Form.Label> آپلود رزومه </Form.Label>
            <Form.Label>
              <div className="input-like-div">
                <p>کلیک کنید</p>
              </div>
              <input type="file" onChange={getFileHandle} id="upload-profile-picture" name="upload-profile-picture" />
            </Form.Label>
          </div>
          <button>
            <AttachIcon />
          </button>
        </Form.Group>  */}

                <Form.Group controlId="resume" className="form_group_badge">
                    <div className="bt-form">
                        <Form.Label>
                            {t(
                                "UserPanel.Profile.OccupationInfo.CVUpload.Place.Holder"
                            )}
                        </Form.Label>
                        <Form.Label htmlFor="upload-profile-picture">
                            <div className="input-like-div">
                                <p>
                                    {t(
                                        "UserPanel.Profile.OccupationInfo.ClickHere.Button"
                                    )}
                                </p>
                            </div>
                            <input
                                type="file"
                                onChange={getFileHandle}
                                id="upload-profile-picture"
                                name="upload-profile-picture"
                            />
                        </Form.Label>
                    </div>
                    {/* <div
                className="error"
                style={{
                  display: error.errUpload || fileName ? "block" : "none",
                  color: error.errUpload ? "red" : "green"
                }}
              >
                {error.errUpload ? error.errUpload : fileName}
              </div>                     */}
                </Form.Group>

                <Form.Group></Form.Group>

                <div className="btn-group">
                    <button onClick={sendData} className=" blue loader-bt">
                        {spLoader ? (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        ) : (
                            <>
                                {t(
                                    "UserPanel.Profile.LivingPlaceInfo.SaveChanges.Button"
                                )}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}
